import { useEffect, useState } from "react";
import api from "@/lib/api";
import { NotePencil, X } from "@phosphor-icons/react";

export function MemberNotices() {
  const [notices, setNotices] = useState([]);
  useEffect(() => { api.get("/me/notices").then((r) => setNotices(r.data)).catch(() => {}); }, []);
  const dismiss = (id) => {
    setNotices((n) => n.filter((x) => x.id !== id));
    api.post(`/me/notices/${id}/dismiss`).catch(() => {});
  };
  if (!notices.length) return null;
  return (
    <div className="space-y-2 mb-6" data-testid="member-notices">
      {notices.map((n) => (
        <div key={n.id} className="flex items-start gap-3 rounded-md border border-primary/30 bg-accent px-4 py-3" data-testid={`member-notice-${n.id}`}>
          <NotePencil size={18} weight="bold" className="mt-0.5 shrink-0 text-primary" />
          <p className="flex-1 text-sm">
            <span className="font-semibold">{n.by}</span> updated your membership information on {new Date(n.created_at).toLocaleDateString()}: {n.fields.join(", ")}.
            {" "}If something looks wrong, contact your Regional Secretary.
          </p>
          <button type="button" onClick={() => dismiss(n.id)} aria-label="Dismiss notice" className="opacity-70 hover:opacity-100" data-testid={`member-notice-dismiss-${n.id}`}><X size={16} weight="bold" /></button>
        </div>
      ))}
    </div>
  );
}
